module.exports = __webpack_public_path__ + "static/media/questionnaire.54825143.svg";